import { defineComponent as e, Types as t } from "bitecs";
const o = e({
  entity: t.i32
});
export {
  o as Parent
};
//# sourceMappingURL=components.js.map
